import * as React from 'react';
import { getSourceDomainSVG } from '../../reducers/contexts-model';

interface IProps {
    url: string
}

export const DomainLogo: React.FC<IProps> = (props) => {
    const logoName = getSourceDomainSVG(props.url);
    const domainLogo = '<svg class="icon icon-Red-Book" height="24px" width="24px"><use xlink:href="#' + logoName + '"></use></svg>';
    if (logoName.length <= 0) {
        return null;
    }
    return (
        <div className="search-result-domain-logo" dangerouslySetInnerHTML={{ __html: domainLogo }} />
    );
}